export default __webpack_public_path__ + "static/media/event_join.28ed6c2b.svg";